import React from 'react';
import { type NavItemNoIcon, type SiteConfig } from '@cx-web/domain-types';
import classNames from 'classnames';

import { HeaderNavItem } from '../HeaderNavItem/index';
import { ScrollableNav } from '../ScrollableNav/index';
import { TertiaryHeaderMenuItems } from '../TertiaryHeaderMenuItems/index';

import styles from './TertiaryHeaderNavGroup.module.css';

type TertiaryHeaderNavGroupProps = {
  bookmakers: SiteConfig['bookmakers'];
  isUkStyle?: boolean;
  navigationKey?: string;
  serverUrl: string;
  thirdLevelNav: NavItemNoIcon[];
};

const TertiaryHeaderNavGroup = ({
  bookmakers,
  isUkStyle,
  navigationKey,
  serverUrl,
  thirdLevelNav,
}: TertiaryHeaderNavGroupProps) => {
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const links = thirdLevelNav;

  if (!links || !links.length) {
    return null;
  }

  return (
    <section className={classNames(styles.container, isUkStyle && styles.uk)} data-testid="tertiary-header-section">
      <nav className={styles.content}>
        {isUkStyle ? (
          // New design: overflow the tail into "More" (mirrors L1). Legacy keeps the ScrollableNav below.
          <TertiaryHeaderMenuItems
            bookmakers={bookmakers}
            dropdownRef={dropdownRef}
            links={links}
            serverUrl={serverUrl}
          />
        ) : (
          <ScrollableNav
            autoScrollToSelected
            navItemsClassName={styles.links}
            navigationKey={navigationKey}
            style={
              {
                '--fade-bg-color': 'var(--cxy-color-midnight-blue-600)',
                '--nav-bg-color': 'var(--cxy-color-midnight-blue-600)',
              } as React.CSSProperties
            }
            testId="tertiary-header-nav"
          >
            {links.map((link, index) => (
              <React.Fragment key={`${link.link}-${index}`}>
                <HeaderNavItem
                  {...link}
                  bookmakers={bookmakers}
                  dropdownRef={dropdownRef}
                  isUkStyle={isUkStyle}
                  serverUrl={serverUrl}
                  variant="tertiary"
                />
              </React.Fragment>
            ))}
          </ScrollableNav>
        )}
        <div className={styles.dropdownWrapper} ref={dropdownRef} />
      </nav>
    </section>
  );
};

export { TertiaryHeaderNavGroup };
